import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListPenghasilan } from "@/services/getData"

export default function MasterPenghasilanPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listPenghasilan"],
    queryFn: getListPenghasilan,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
